@if(entityIsLoaded()) {
<nav class="av-breadcrumb" aria-label="Breadcrumb">
  <ol class="av-breadcrumb__list">
    @for (item of items; track $index) {
    <li class="av-breadcrumb__item">
      @if ($index > 0) {
      <span class="av-breadcrumb__separator" aria-hidden="true">></span>
      }
      @if (item.link) {
      <a [routerLink]="item.link" class="av-breadcrumb__link">
        @if (item.translate !== false) {
        {{ item.label | translate }}
        } @else {
        {{ item.label }}
        }
      </a>
      } @else {
      <span class="av-breadcrumb__current">
        @if (item.translate !== false) {
        {{ item.label | translate }}
        } @else {
        {{ item.label }}
        }
      </span>
      }
    </li>
    }
  </ol>
</nav>
}